import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import './styles/global.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { completeEmailLinkSignInIfPresent } from './completeEmailLinkSignIn';

const root = ReactDOM.createRoot(document.getElementById('root'));

void completeEmailLinkSignInIfPresent()
  .catch(() => {
    // Error already logged in completeEmailLinkSignInIfPresent
  })
  .finally(() => {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
  });

// Performance monitoring - log web vitals to console in development
if (process.env.NODE_ENV === 'development') {
  reportWebVitals(console.log);
} else {
  // In production, you can send to analytics:
  // reportWebVitals((metric) => {
  //   analytics.track('web-vital', metric);
  // });
  reportWebVitals();
}
